module.exports = __webpack_public_path__ + "img/LOGO_2852_1_2.6fe38a34.svg";